import { Divider } from "@mantine/core";
import AnalyticsCards from "./components/AnalyticsCards";
import AUMHero from "./components/AUMHero";
import SavingsHero from "./components/SavingsHero";
// import DevicesOverview from "./components/DevicesOverview";
// import Overview from "./components/Overview";
import StocksAlert from "./components/StocksAlert";

const DashboardPage = () => {
  return (
    <div className="w-full flex flex-col gap-10">
      {/* <Overview /> */}
      {/* <Divider color="gray.3" /> */}
      <div className="w-full grid grid-cols-2 gap-4">
        <AUMHero />
        <SavingsHero />
      </div>
      <Divider color="gray.3" />
      <AnalyticsCards />
      <Divider color="gray.3" />
      <StocksAlert />
      {/* <Divider color="gray.3" /> */}
      {/* <DevicesOverview /> */}
    </div>
  );
};

export default DashboardPage;
